"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ReturnFooter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _excluded = ["containerStyle", "title", "onPress", "cancelStyle"];
function ReturnFooter(props) {
  var containerStyle = props.containerStyle,
    title = props.title,
    onPress = props.onPress,
    cancelStyle = props.cancelStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, containerStyle]
  }, /*#__PURE__*/_react["default"].createElement(_Anchor["default"], (0, _extends2["default"])({
    style: cancelStyle,
    title: title,
    onPress: onPress
  }, rest)));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  }
});